import { render, staticRenderFns } from "./HostelApplyList.vue?vue&type=template&id=3f46f088&scoped=true&"
import script from "./HostelApplyList.vue?vue&type=script&lang=js&"
export * from "./HostelApplyList.vue?vue&type=script&lang=js&"
import style0 from "./HostelApplyList.vue?vue&type=style&index=0&id=3f46f088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f46f088",
  null
  
)

export default component.exports